import {Order} from "./shop/order.model";

/**
 * Model reprezentujący pełne żądanie zwrotu środków (Refund Request).
 * Śledzi cały cykl życia zwrotu – od momentu zgłoszenia przez pacjenta/recepcję,
 * przez rozliczenia finansowe, aż po procesy księgowe (faktury korygujące).
 */
export class RefundRequest {

  /** Globalnie unikalny identyfikator żądania zwrotu. */
  public uuid: string;
  public created: Date;
  public modified: Date;
  public deleted: Date;

  /** Vetcode placówki weterynaryjnej, której dotyczy ten zwrot. */
  public vetcodeId: number;

  /** Identyfikator pacjenta, który wnioskuje o zwrot. */
  public userUUID: string;

  /** Identyfikator odwołanej wizyty powiązanej z tym zwrotem. */
  public vetReservationUUID: string;

  /** Główny identyfikator pierwotnego zamówienia / transakcji.
   * Kluczowy do odnalezienia oryginalnej wpłaty w systemie i bramce płatniczej.
   */
  public orderUUID: string;

  /** Pełny obiekt zamówienia. */
  public order: Order;

  /** Imię klienta (Vet Reservation Name). */
  public vrName: string;
  /** Nazwisko klienta. */
  public vrSurname: string;
  /** Numer telefonu klienta do ewentualnego kontaktu w sprawie zwrotu. */
  public vrPhone: string;


  /** Ostateczny termin, do którego rezerwacja mogła zostać anulowana.
   */
  public reservationCancellationExpirationDate: Date;

  /** Data fizycznego przetworzenia i zaksięgowania zwrotu. */
  public refundDate: Date;

  /** Aktualny status żądania. */
  public status: string;

  /** Główna flaga potwierdzająca, że proces zwrotu został ostatecznie sfinalizowany. */
  public wasRefund: boolean;

  /** Typ żądania. */
  public type: string;

  /** Tekstowy powód zwrotu. */
  public refundReason: string;

  /** Całkowita kwota, która została zwrócona pacjentowi. */
  public amountRefunded: number;

  /** Procentowa wartość zwrotu w stosunku do ceny wizyty.
   */
  public percentageVetReservationRefundValue: number;

  /** Kwota zwrotu, która obciąża konto operatora platformy Vetineo.
   */
  public amountRefundedFromVetineo: number;

  /** Data i czas wysłania faktury korygującej. */
  public correctiveInvoiceEmailSent: Date;

  /** Data i czas wysłania kopii faktury korygującej do biura kliniki. */
  public correctiveInvoiceEmailSentToOffice: Date;

  /** Korekta faktury powinna być wysłana do KSeF. */
    public shouldBeSendToKSeF: boolean;

  /** Id faktury w KSeF. */
  public correctiveKSeFInvoiceId: string;

}
